import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES, AUTH_SCOPE } from '@profile-ui-mono/utilities/constants';
import useThrowAsyncError from './useThrowAsyncError';

const STORAGE_KEY = 'profile_redirect_url';

const getRedirectPath = () => {
  const storedRedirectUrl = window.sessionStorage.getItem(STORAGE_KEY);
  if (storedRedirectUrl) {
    try {
      const redirectUrl = new URL(storedRedirectUrl);
      return redirectUrl.pathname.split('/')[1] || '';
    } catch (e) {
      return '';
    }
  }
  return '';
};

const useLoginPageAuthRegister = () => {
  const navigate = useNavigate();
  const throwAsyncError = useThrowAsyncError();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const redirectPath = getRedirectPath();

  const registerAuthAndCheckLogin = useCallback(async () => {
    const auth = window.cfp.providers.auth;
    try {
      const authConfig = {
        clientId: window.$profileEnvVars.ADSK_APS_CLIENT_ID,
        environment: window.$profileEnvVars.REACT_APP_STAGE,
        redirectUri: window.location.origin + '/pkceredirect.html',
        scope: AUTH_SCOPE,
      };
      await auth.register(authConfig);
    } catch (error) {
      if (!(error.message && error.message.includes('already been registered'))) {
        setIsCheckingAuth(false);
        throwAsyncError(error);
        return;
      }
    }
    try {
      const isLoggedIn = await auth.isLoggedIn();
      if (isLoggedIn) {
        const storedRedirectUrl = window.sessionStorage.getItem(STORAGE_KEY);
        if (storedRedirectUrl) {
          const redirectUrl = new URL(storedRedirectUrl);
          window.sessionStorage.removeItem(STORAGE_KEY);
          navigate(redirectUrl.pathname, { replace: true });
          return;
        }
        navigate(ROUTES.HOME, { replace: true });
      } else {
        setIsCheckingAuth(false);
      }
    } catch (error) {
      setIsCheckingAuth(false);
      throwAsyncError(error);
    }
  }, [navigate, throwAsyncError]);

  useEffect(() => {
    registerAuthAndCheckLogin();

    const handlePageShow = (event) => {
      if (event.persisted) {
        setIsCheckingAuth(true);
        registerAuthAndCheckLogin();
      }
    };

    window.addEventListener('pageshow', handlePageShow);
    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [registerAuthAndCheckLogin]);
  const hookResult = ({ isCheckingAuth, redirectPath });
  return hookResult;
};

export default useLoginPageAuthRegister; 